import {omit} from 'lodash'
import {subdomainLink} from '../../../helpers/url'
import React, {useState} from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../context'
import {cloneAssessment, deleteAssessment} from '../../../context/post'
import Icon from '../../icon'
import {faEdit, faTrashAlt, faClone} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import confirmDialog from '../../confirm-dialog'
import {confirmAlert} from 'react-confirm-alert'
import ScheduleAssessment from '../../schedule-assessment'
import {viewerGuard} from 'helpers/url'
import 'react-confirm-alert/src/react-confirm-alert.css'
import './links.styl'

function DuplicateDialog (props) {
  const {context, assessment, onClose} = props
  const {translate, setState, assessmentUpdates} = context
  const [name, setName] = useState(assessment.name || "") 
  return (
    <div className="duplicate-dialog">
      <div className="title">
        {translate('duplicate_assessment_label')}
      </div>
      <div className="input">
        <input
          value={name}
          type="text"
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div className="buttons">
        <div
          className="duplicate button"
          onClick={() => {
            cloneAssessment(assessment, name).then(() => {
              setState({assessmentUpdates: assessmentUpdates + 1}, onClose)
            })
          }}
        >
          {context.translate('duplicate_label')}
        </div>
        <div className="cancel button" onClick={onClose}>
          {translate('cancel_label')}
        </div>
      </div>
    </div>
  )
}

function duplicateDialog (props) {
  return confirmAlert({
    customUI: ({onClose}) => (<DuplicateDialog {...{...props, onClose}}/>)
  })
}

export default function Links (props) {
  return (<Consumer>{ context => {
    const {assessments, languageId, link, action} = context
    const {digest} = assessments.find(a => a.id == props.id) || {}
    return (
      <div className="links">
          {digest && (
            <div className="link edit">
              <a
                {...viewerGuard({ href:subdomainLink('assessment',languageId, `create#${digest}`), target: "_blank"})}>
                <FontAwesomeIcon icon={faEdit} />
              </a>
            </div>
          )}
          { action == 'schedule' && (<ScheduleAssessment
            selectedGroup={{}}
            activeTab='groups'
            />)}
          <div className="link schedule">
            <Link to={link({assessment: props.id}, `${context.match.path}/schedule/:assessment`, {preserveQuery: true}) }>
              <Icon name="schedule" />
            </Link>
          </div>
          { props.used && (<div className="link delete inactive"><FontAwesomeIcon icon={faTrashAlt} /></div>)}
          { !props.used && (<div
            className="link delete"
            onClick={ () =>
              confirmDialog({
                className: 'delete-assessment',
                translate: context.translate,
                children: (
                  <div className="message">
                    <div className="question">
                      {context.translate('confirm_delete_item')}
                    </div>
                    <div className="title">
                      {props.name}
                    </div>
                  </div>
                ),
                onConfirm: () => {
                  deleteAssessment(props.teacher, props.id).then(() => {
                    const assessmentUpdates = context.assessmentUpdates + 1
                    context.setState({assessmentUpdates})
                  })
                }
              })
            }
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </div>)}
        <div className="link" onClick={() => duplicateDialog({context, assessment: props})}>
          <FontAwesomeIcon icon={faClone} />
        </div>
      </div>
    )
  }}</Consumer>)
}
